import React from "react";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import UpgradeCardHeader from "./UpgradeCardHeader";
import UpgradeSummary from "./UpgradeSummary";
import PlanFeaturesList from "./PlanFeaturesList";
import UpgradeButton from "./UpgradeButton";
import UpgradeCardFooter from "./UpgradeCardFooter";

const UpgradeCard = ({
  variants,
  newPlan,
  currentPlanName,
  onUpgradeClick,
  isTrial,
  isLoading,
}) => (
  <motion.div variants={variants}>
    <Card className="shadow-xl bg-gradient-to-br from-card via-background to-secondary/10 border-primary/20">
      <UpgradeCardHeader newPlan={newPlan} isTrial={isTrial} />

      <CardContent className="space-y-6">
        <UpgradeSummary
          currentPlanName={currentPlanName}
          isTrial={isTrial}
          newPlan={newPlan}
        />

        <PlanFeaturesList newPlan={newPlan} />

        <UpgradeButton
          onUpgradeClick={onUpgradeClick}
          isLoading={isLoading}
          isTrial={isTrial}
        />
      </CardContent>

      <UpgradeCardFooter isTrial={isTrial} />
    </Card>
  </motion.div>
);

export default UpgradeCard;
